/**
 * Hands the page's CSP nonce to webpack before anything renders.
 *
 * The backend nonce-locks `style-src` and publishes the per-request nonce on
 * `window.__webpack_nonce__` (core/spa_index.py). A plain window property is
 * not what libraries read: react-style-singleton (Radix scroll-lock, used by
 * every dropdown and dialog) stamps its injected `<style>` with webpack's own
 * nonce, `__webpack_require__.nc`, which only an assignment to the
 * `__webpack_nonce__` free variable sets. Without this the style was injected
 * un-nonced and blocked, logging a CSP error each time a menu opened.
 *
 * Imported first in index.tsx so it runs before any component mounts.
 */
declare global {
  // eslint-disable-next-line no-var
  var __webpack_nonce__: string | undefined;
}

const pageNonce = window.__webpack_nonce__;
if (pageNonce) {
  __webpack_nonce__ = pageNonce;
}

export {};
